import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
	ErrorStatusTypes,
	ErrorsStack,
	parseErrorMessage,
} from "../common/errorsDeclarations";

import * as allegatiApi from "../../api/allegati/allegatiApi";
import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";

export interface TipoDocumento {
	id: number;
	nome: string;
	descrizione?: string;
}
export interface TipiDocumento {
	count: number;
	page: number;
	num_pages: number;
	next?: URL;
	previous?: URL;
	results: TipoDocumento[];
    errorsStack: ErrorsStack;
}

export interface Allegato {
	id: number | null;
	tipo_documento: number | null;
	tipo_documento_des?: TipoDocumento;
	descrizione: string;
    previsione?: number | null;
	preview?:boolean;

	autore: string;
	file: string;
}

export interface Allegati {
	count: number;
	page: number;
	num_pages: number;
	next?: URL;
	previous?: URL;
	results: Allegato[];
	errorsStack: ErrorsStack;
}

export interface AllegatiState {
	allegato: Allegato;
	errorsStack: ErrorsStack;
}

export interface AllegatiStrutturaState {
	tipiDocumento: TipiDocumento;
	allegati: Allegati;
	allegatoCorrente: AllegatiState;

}

const initialState: AllegatiStrutturaState = {
	tipiDocumento: {
		count: 0,
		page: 0,
		num_pages: 0,
		next: undefined,
		previous: undefined,
		results: [],
        errorsStack: { status: ErrorStatusTypes.OK },
	},
	allegati: {
		count: 0,
		page: 0,
		num_pages: 0,
		next: undefined,
		previous: undefined,
		results: [],
		errorsStack: { status: ErrorStatusTypes.OK },
	},
	allegatoCorrente: {
		allegato: {
			id: null,
			tipo_documento: null,
			descrizione: "",
            previsione: null,
			autore: "",
			file: "",
		},
		errorsStack: { status: ErrorStatusTypes.OK },
	},
};

export const fetchTipiDocumento = createAsyncThunk(
	"allegato/fetchTipiDocumento",
	async () => {
		return await allegatiApi.fetchTipiDocumento();
		//   return user;
	}
);
export const fetchAllegati = createAsyncThunk(
	"allegato/fetchAllegati",
	async (parametri: {
		previsione_id?: number | null;
		// pagamento_id?: number | null;
		tipo_documento_id?: number;
		preview?: boolean
	}) => {
		return await allegatiApi.fetchAllegati(
			parametri.previsione_id,
			// parametri.pagamento_id,
			parametri.tipo_documento_id,
			parametri.preview
		);
		//   return user;
	}
);

export const uploadAllegato = createAsyncThunk(
	"allegato/uploadAllegato",
	async (
		parametriAllegato: {
			allegato: Allegato;
			file: File;
		},
		thunkApi
	) => {
		return await allegatiApi
			.uploadAllegato(parametriAllegato.allegato, parametriAllegato.file)
			.then((response) => {
				thunkApi.dispatch(
					fetchAllegati({
						// previsione_id: parametriAllegato.allegato.previsione,
						// pagamento_id: parametriAllegato.allegato.pagamento,
					})
				);
				return response;
			});
	}
);

export const deleteAllegato = createAsyncThunk(
	"schedaCarico/deleteAllegato",
	async (allegatoToDelete: Allegato, thunkApi) => {
		const previsione_id = allegatoToDelete.previsione;
		return await allegatiApi
			.deleteAllegato(allegatoToDelete)
			.then((response) => {
				return response;
			});
	}
);

export const allegatiSlice = createSlice({
	name: "allegatiSlice",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		// fetch tipiDocumento
		builder.addCase(fetchTipiDocumento.pending, (state, action) => {
			// state.tipiDocumento.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(fetchTipiDocumento.fulfilled, (state, action) => {
			state.tipiDocumento = action.payload;
			// state.tipiDocumento.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(fetchTipiDocumento.rejected, (state, action) => {
			state.allegati.errorsStack = parseErrorMessage(action.error);
		});
		// fetch Allegati
		builder.addCase(fetchAllegati.pending, (state, action) => {
			state.allegati.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(fetchAllegati.fulfilled, (state, action) => {
			state.allegati.results = action.payload.results
			// state.allegati.results = [
			// 	...state.allegati.results.filter(
			// 		(allegato) =>
			// 			(!!action.meta.arg.previsione_id &&
			// 				allegato.previsione != action.meta.arg.previsione_id)
			// 	),
			// 	...action.payload.results,
			// ];

			state.allegati.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(fetchAllegati.rejected, (state, action) => {
			state.allegati.errorsStack = parseErrorMessage(action.error);
		});
		// fetch Allegati
		builder.addCase(deleteAllegato.pending, (state, action) => {
			state.allegati.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(deleteAllegato.fulfilled, (state, action) => {
			state.allegati.results = state.allegati.results.filter(
				(allegato) => allegato.id != action.meta.arg.id
			);
			toast.success(action.payload.message || "Allegato cancellato.");
			state.allegati.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(deleteAllegato.rejected, (state, action) => {
			state.allegati.errorsStack = parseErrorMessage(action.error);
		});
		// carica Documento
		builder.addCase(uploadAllegato.pending, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.PENDING };
		});
		builder.addCase(uploadAllegato.fulfilled, (state, action) => {
			state.allegatoCorrente.errorsStack = { status: ErrorStatusTypes.OK };
			toast.success("Allegato inserito.");
		});
		builder.addCase(uploadAllegato.rejected, (state, action) => {
			state.allegatoCorrente.errorsStack = parseErrorMessage(action.error);
		});
	},
});

// Action creators are generated for each case reducer function
// export const {} = allegatiSlice.actions;

export const allegatiSliceReducer = allegatiSlice.reducer;
